import React, { Component } from 'react';
// let arrAnswers = []
class StructQuestion extends Component{

    constructor(props) {
        super(props);
        this.state = {
            buttonSubmit: 'disabled'
        }
    }

    
    // CONTENEDOR ENCUESTA
    render() {
        return(
            <div>
                {this.sectionCuestion(this.props.arrQuestions.encuesta)}
            </div>
        );
    }

    // LISTADO DE CATEGORIAS CON SUS RESPECTIVAS PREGUNTAS
    sectionCuestion = (arrCategories) => {
        return (
            <div>
                {Object.values(arrCategories).map((categoria, i) => (
                    <div key={i}>
                        <div className="col-xs-12">
                            {/* Se deja fijo el valor 0 y 4 ya que de momento las primeras 4 categorias pertencen a un tipo de calificacion y el resto a otro */}
                            {(i == 0 || i == 4) ? this.messageInstructions(i) : ''}
                            <div className="categoria-section">
                                <div key={i} className="col-xs-6 title_categoria">
                                    <p className="categoria">{categoria.titulo}</p>
                                </div>
                                <div className="col-md-3 indicator_section">
                                    <center>
                                        {this.indicatorQuestion()}
                                    </center>
                                </div>
                                <div className="col-md-3 indicator_section">&nbsp;</div>
                            </div>
                        </div>
                        <div>
                            {this.bodyQuestion(categoria.pregunta)}
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    // ESTRUCTURA DE PREGUNTA

    bodyQuestion = (pregunta) => {
        return (
           <div>
               {Object.values(pregunta).map((pregunta, key) => (
                    <div key={pregunta.id} className="col-xs-12">
                        <div className="form-group col-md-6">
                            <p className="pregunta">- {pregunta.pregunta}</p>
                        </div>
                        { !(pregunta.tipo == 'Abierta') 
                        ?   <div>
                                <div className="form-group col-md-3 text-center">
                                {this.optionsRadioButton(pregunta.id, 6, pregunta.categoria_id)}
                                </div>
                                <div className="form-group col-md-3">
                                    <textarea className="form-control" placeholder="Comentarios" question={pregunta.id} categoria={pregunta.categoria_id} onChange={this.props.handleInputChangeComent} />
                                </div>
                            </div>
                        :   <div className="form-group col">
                                <textarea className="form-control" placeholder="Comentarios" question={pregunta.id} categoria={pregunta.categoria_id} onChange={this.props.handleInputChangeComent} />
                            </div>
                        }
                    </div>
                ))}
           </div> 
        )
    }

    // INPUTS RADIO BUTTONS PARA INDICAR CALIFICACION
    optionsRadioButton = (idQuestion, totalQuestions, idCategoria) => {
        var radioButtons = []
        for (let index = 1; index <= totalQuestions; index++ ) {
            let calificacion = (index <= 5) ? (5) + (index) : 0
            let indicatorText = (index <= 5) ? index : 'N/A'
            radioButtons.push(
                <label key={index} htmlFor="quetion" className="col-md-2 indicator-question">
                    <i className="indicator_mobile">{indicatorText}</i>
                    <input type="radio" name={'calificacion_'+idQuestion} question={idQuestion} categoria={idCategoria} value={calificacion} onChange={this.props.handleInputChangeRadio} required/>
                </label>
            )
        }
        return ( radioButtons )
    }


    // INDICADOR DE CALIFICACION PREGUNTAS
    indicatorQuestion = () => {
        var labelOndicators = []
        for (let index = 1; index <= 6; index++) {
            if (index <= 5) {
                labelOndicators.push(
                    <label key={index} htmlFor="num" className="indicator-question col-md-2">{index}</label>
                )
            } else {
                labelOndicators.push(
                    <label key={index} htmlFor="num" className="indicator-question col-md-2">N/A</label>
                )
            }
        }
        return (labelOndicators)
    }

    // Mostrar indicaciones de forma dinamica para calificar encuestas
    messageInstructions = (i) => {
        let arrIndicartor = (i == 0) ? {max: 'Totalmente de acuerdo', min: 'En desacuerdo'} : {max: 'Excelente', min: 'Malo'}
        return (
            <div className="alert alert-warning" style={{marginLeft: '-15px', marginRight: '-15px', marginBottom: '0px', border: '0px'}}>
                <p style={{fontSize: '12px'}}>Selecciona del 1 al 5 en cada uno de los conceptos, donde 5 significa “{arrIndicartor.max}” y 1 “{arrIndicartor.min}”.</p>
            </div>
        )
    }
}

export default (StructQuestion)



// WEBPACK FOOTER //
// ./src/guest/improvement/StructQuestion.js